"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonOnboardingDataTypeId = void 0;
var CommonOnboardingDataTypeId;
(function (CommonOnboardingDataTypeId) {
})(CommonOnboardingDataTypeId = exports.CommonOnboardingDataTypeId || (exports.CommonOnboardingDataTypeId = {}));
//# sourceMappingURL=CommonOnboardingDataTypeId.js.map